import {
  naverMapTabUrl,
  naverStreetViewTabUrl,
  type LngLat,
} from "./naver-street-view-url.ts";
import { lookupNearestNaverPano } from "./naver-pano-lookup.ts";

export interface OpenNaverStreetViewTabOptions {
  center: LngLat;
  maplibreZoom: number;
  naverMapKeyId: string;
}

/**
 * Opens a blank tab synchronously (popup-safe), then navigates to Naver street view
 * or map view at the MapLibre center after a client-side panorama lookup.
 */
export function openNaverStreetViewTab(opts: OpenNaverStreetViewTabOptions): void {
  // Avoid noopener so the opener can assign location after async pano lookup (popup-safe).
  const tab = window.open("about:blank", "_blank");
  if (!tab) return;
  const fallback = naverMapTabUrl(opts.center, opts.maplibreZoom);
  const hardNav = window.setTimeout(() => {
    try {
      if (tab.location.href === "about:blank") tab.location.href = fallback;
    } catch {
      /* cross-origin after navigation */
    }
  }, 30_000);
  void resolveNaverStreetViewTabUrl(opts)
    .then((url) => {
      window.clearTimeout(hardNav);
      tab.location.href = url;
    })
    .catch(() => {
      window.clearTimeout(hardNav);
      tab.location.href = fallback;
    });
}

export async function resolveNaverStreetViewTabUrl(opts: OpenNaverStreetViewTabOptions): Promise<string> {
  const pano = await lookupNearestNaverPano(opts.naverMapKeyId, opts.center);
  if (!pano) {
    return naverMapTabUrl(opts.center, opts.maplibreZoom);
  }
  return naverStreetViewTabUrl(opts.center, opts.maplibreZoom, pano.panoId, pano.pov);
}
